import { useEventListener } from '../../../lib/events';
import { VideoRecordingEvent } from '../../action-input';
import { useScoreRecognition } from './use-score-recognition';

const normalizeScore = (score: ReturnType<typeof useScoreRecognition>) => {
	const isDefault = score.dimensions.every((dimension) => !dimension.reason);

	if (isDefault) {
		return -1;
	}

	return score.totalMatches;
};

export const useGratitudeGauge = () => {
	const textScore = useScoreRecognition();
	const transcriptScore = useScoreRecognition();

	useEventListener(VideoRecordingEvent.AttachToBonus, (data: { transcript: string } = { transcript: '' }) => {
		if (data && data.transcript) {
			transcriptScore.onChange(data.transcript);
		}
	});

	const higherScore = Object.assign({}, normalizeScore(transcriptScore) >= normalizeScore(textScore) ? transcriptScore : textScore);

	return {
		dimensions: higherScore.dimensions,
		isFetching: textScore.isFetching || transcriptScore.isFetching,
		text: higherScore.text,
		totalDimensions: higherScore.totalDimensions,
		totalMatches: higherScore.totalMatches,
		onChangeText: textScore.onChange,
		onChangeTranscription: transcriptScore.onChange,
	};
};
